<template>
  <div class="preview-container">

    <!-- 加载失败提示 -->
    <div
        v-if="loadError"
        class="error-tip"
    >
      <el-alert
          type="error"
          :closable="false"
          title="文件加载失败，请检查链接或文件格式"
      />
    </div>


    <!-- 没有文件：显示空状态 -->
    <el-empty
        v-else-if="!fileUrl"
        description="暂无文件"
        class="empty-box"
    />

    <!-- 有文件：显示预览 -->
    <office-viewer
        v-else
        :src="fileUrl"
        :type="fileType"
        @loaded="onLoaded"
        @error="onError"
    />

  </div>
</template>

<script>
import OfficeViewer from '@/components/officeViewer.vue'

export default {
  components: {OfficeViewer},

  data() {
    return {
      fileUrl: '',
      fileType: '',
      loadError: false
    }
  },

  created() {
    this.loadFromQuery()
  },

  methods: {
    /** 判断文件类型 */
    inferFileType(url) {
      if (!url) return ''

      const u = url.toLowerCase()

      // Word
      const wordExt = ['.doc', '.docx', '.dot', '.dotx']
      if (wordExt.some(ext => u.endsWith(ext))) {
        return 'docx'
      }

      // Excel
      const excelExt = ['.xls', '.xlsx', '.xlsm', '.xlsb', '.csv']
      if (excelExt.some(ext => u.endsWith(ext))) {
        return 'xlsx'
      }

      // PDF
      if (u.endsWith('.pdf')) {
        return 'pdf'
      }

      return ''
    },


    /** 从 URL 自动读取 ?url= 参数 */
    loadFromQuery() {
      const url = this.$route.query.url
      if (!url) return
      this.fileUrl = decodeURIComponent(url)
      this.fileType = this.inferFileType(this.fileUrl)
    },

    onLoaded() {
      this.loadError = false
      console.log("文件加载成功")
    },

    onError(err) {
      this.loadError = true
      console.error("文件加载失败:", err)
    }
  }
}
</script>

<style scoped>
.preview-container {
  height: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.empty-box {
  margin-top: 200px;
}

.error-tip {
  padding: 20px;
  box-sizing: border-box;
}
</style>
